import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUntagItem(collection, id) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (title) => {
      if (collection && id && title) {
        const existingTags = await api
          .post('pipeline/tags', {
            json: [
              { $match: { title } },
              { $project: { _id: false, identifier: true, items: true } },
            ],
          })
          .json();

        const taggedItemsCount = Object.values(existingTags[0].items).reduce(
          (acc, itemIds) => acc + itemIds.length,
          0,
        );

        if (taggedItemsCount === 1) {
          return api.delete(`tags/${existingTags[0].identifier}`).json();
        } else {
          const items = {
            ...existingTags[0].items,
            [collection]: existingTags[0].items[collection].filter(
              (itemId) => itemId !== id,
            ),
          };

          return api
            .patch(`tags/${existingTags[0].identifier}`, {
              headers: { 'content-type': 'application/merge-patch+json' },
              json: { items },
            })
            .json();
        }
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['tags'] }),
  });
}
